import type { DetailedHTMLProps, ImgHTMLAttributes } from 'react';

export type LogoProps = Omit<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
  'src' | 'alt'
>;

export default function Logo(props: LogoProps) {
  return (
    <img src="/images/angel-clinicians.svg" alt="Angel Clinicians" {...props} />
  );
}
